export default "__VITE_ASSET__Barhdr6c__"